import Container from "@/components/Container/Container.tsx";
import { ChevronLeft } from "@/components/Icons/utility/ChevronLeft.tsx";
import { PageOverlayLoader } from "@/components/Loader/OverlayLoader/OverlayLoader.tsx";
import { ReservationAccommodationExtras } from "@/components/ReservationOptions/ReservationAccommodationExtras/ReservationAccommodationExtras.tsx";
import { ReservationSidebar } from "@/components/ReservationSidebar/ReservationSidebar.tsx";
import { ReservationSteps } from "@/components/ReservationSteps/ReservationSteps.tsx";
import { scrollToTop } from "@/helpers/scrollToTop.ts";
import { useCartDrawerState } from "@/helpers/useCartDrawerState.ts";
import { ExtraOptionsProps } from "@/pages/ExtraOptions/ExtraOptionsProps.ts";
import { useValidateExtraOptionsStep } from "@/pages/ExtraOptions/hooks/useValidateExtraOptionsStep.ts";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

export const ExtraOptions = (props: ExtraOptionsProps) => {
  const { t } = useTranslation();
  const { handleCloseCartDrawer } = useCartDrawerState();
  const { setPage, cartAccommodationItems } = useEngineStore(
    useShallow((state) => ({
      setPage: state.setPage,
      cartAccommodationItems: state.cartAccommodationItems,
    })),
  );
  const { areParcelVehicleDimensionsMissing, isCaravanMoverMissing } = useValidateExtraOptionsStep();

  const renderCartItemExtras = () => {
    return cartAccommodationItems?.map((item) => (
      <div key={item.id} className="extrasOptions c-extras__options">
        <div className="optionsWrap c-reservation-options">
          <div className="optionsInnerWrap">
            <ReservationAccommodationExtras key={item.id} item={item} />
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <header className="o-header">
        <Container>
          <div className="c-be-booking-navigation">
            <div className="c-be-booking-navigation__left">
              <button
                className="c-be-link"
                onClick={() => {
                  setPage(AppPage.AccommodationPicking);
                  handleCloseCartDrawer();
                  scrollToTop();
                }}
              >
                <span className="c-be-link__prefix">
                  <ChevronLeft />
                </span>
                <span className="c-be-link__label">{t("backToSelAcc")}</span>
              </button>
            </div>
            <div className="c-be-booking-navigation__right">
              <ReservationSteps />
            </div>
          </div>
        </Container>
      </header>
      <main className="extrasWrap o-page">
        <PageOverlayLoader loading={props.reservationOfferLoading} text={t("loadingReservationOffer")}>
          <div className={`o-page__inner ${props.reservationOfferLoading ? "o-page__inner-hidden" : ""}`}>
            <section className="c-extras-wrapper">
              <Container>
                <div className="c-extras">
                  <div className="c-extras__accommodations-list">
                    <header className="c-extras__accommodations-header">
                      <h3 className="u-h5 u-fw-600">{t("step1")}</h3>
                    </header>
                    {renderCartItemExtras()}
                  </div>
                  <div className="extrasSummary c-extras__summary">
                    <div className="c-extras__summary-inner">
                      <ReservationSidebar
                        hideRemoveRate
                        continueBtnPopoverText={
                          areParcelVehicleDimensionsMissing
                            ? t("parcelVehicleDimensionsMissing")
                            : isCaravanMoverMissing
                            ? t("caravanMoverMissing")
                            : undefined
                        }
                        continueDisabled={areParcelVehicleDimensionsMissing || isCaravanMoverMissing}
                        onContinue={() => {
                          setPage(AppPage.HolderAndPaymentInfo);
                          handleCloseCartDrawer();
                          scrollToTop();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Container>
            </section>
          </div>
        </PageOverlayLoader>
      </main>
    </div>
  );
};
